/* eslint-disable @typescript-eslint/no-unused-vars */
import {createContext} from 'react';
import {MatrixEvent} from 'matrix-js-sdk';
import {
  Multimedia,
  MultimediaDownloadInfo,
  MultimediaFileInfo,
  MultimediaUploadInfo,
  SystemMessageAction,
  SystemMessageData
} from '@/types/matrix';

type MatrixRoomContextType = {
  lastEventSentByUser: boolean;
  currentMatrixRoomId: string | null;
  matrixEvents: MatrixEvent[];
  updateMatrixEventsState: (events: MatrixEvent[]) => void;
  addMatrixEvent: (event: MatrixEvent) => void;
  updateMatrixEvent: (updatedEvent: MatrixEvent) => void;
  initMatrixRoom: (
    invitedUserId?: string,
    existingRoomId?: string
  ) => Promise<
    | void
    | {
        room_id: string;
      }
    | undefined
  >;
  loadOlderMatrixEvents: () => Promise<void>;
  readyToHandlePagination: boolean;
  matrixEventToQuote: MatrixEvent | null;
  setMatrixEventToQuote: (event: MatrixEvent | null) => void;
  activeMatrixEvent: MatrixEvent | null;
  multimediaFiles: MultimediaFileInfo[];
  isRoomJoined: boolean;
  isLoadingRoom: boolean;
  setActiveMatrixEvent: (event: MatrixEvent | null) => void;
  handleSendMatrixTextMessage: (messageText: string) => void;
  handleDeleteMatrixEvent: (
    eventToDelete?: MatrixEvent,
    eventsToDelete?: MatrixEvent[]
  ) => void;
  lastSentMatrixEvent: MatrixEvent | null;
  handleSendSystemMessage: (
    actionType: SystemMessageAction,
    messageAdditionalDataType: SystemMessageData
  ) => void;
  handleListScrolledToNewestEvent: () => void;
  handleResetMatrixEventsUpdatedState: () => void;
  matrixEventsUpdated: boolean;
  userDialogOpen: boolean;
  multimediaDialogOpen: boolean;
  isSendingEvent: boolean;
  finishedSendingImages: boolean;
  windowChatOpen: boolean;
  multimediaEventsToSend: number;
  multimediaTypeUploaded: Multimedia | null;
  handleOpenUserDialog: () => void;
  handleCloseUserDialog: () => void;
  handleMouseEnterEvent: (hoveredEvent: string) => void;
  handleMouseLeaveEvent: () => void;
  currentHoveredEvent: string | null;
  handleSetEventRead: (eventToSetRead: MatrixEvent) => void;
  handleSetAllEventsRead: () => void;
  handleOpenMultimediaDialog: () => void;
  handleCloseMultimediaDialog: () => void;
  handleCancelMultimediaFileUpload: (index: number) => void;
  handleDownloadSingleMultimedia: (
    multimediaInfo: MultimediaDownloadInfo
  ) => void;
  handleDownloadMultipleMultimedia: (
    multimediaInfo: MultimediaDownloadInfo[]
  ) => void;
  handleDeleteImage: (
    parentImage: MatrixEvent,
    imageToDeleteUrl: string
  ) => void;
  handleFinishedSendingImages: () => void;
  handleResetSendingImagesState: () => void;
  handleUploadMultimediaFiles: (filesToUpload: MultimediaUploadInfo[]) => void;
  handleSendMultimediaFiles: (
    multimediaFiles: MultimediaFileInfo[],
    text: string
  ) => void;
  handleSelectMultimediaTypeUploaded: (multimediaType: Multimedia) => void;
  handleCloseWindowChat: () => void;
  handleSendDirectMessage: (message: string, invitedUserMail: string) => void;
};
const defaultContext: MatrixRoomContextType = {
  initMatrixRoom: async (invitedUserId, existingRoomId): Promise<void> => {
    //
  },
  lastEventSentByUser: false,
  currentMatrixRoomId: null,
  readyToHandlePagination: true,
  matrixEventToQuote: null,
  lastSentMatrixEvent: null,
  matrixEvents: [],
  updateMatrixEventsState: (events) => {
    //
  },
  addMatrixEvent: (event) => {
    //
  },
  updateMatrixEvent: (updatedEvent) => {
    //
  },
  loadOlderMatrixEvents: async () => {
    //
  },
  setMatrixEventToQuote: () => {
    //
  },

  activeMatrixEvent: null,
  matrixEventsUpdated: false,
  userDialogOpen: false,
  currentHoveredEvent: null,
  multimediaDialogOpen: false,
  multimediaFiles: [],
  isRoomJoined: false,
  isLoadingRoom: true,
  isSendingEvent: false,
  finishedSendingImages: false,
  multimediaEventsToSend: 0,
  multimediaTypeUploaded: null,
  windowChatOpen: false,

  setActiveMatrixEvent: (event) => {
    //
  },
  handleSendMatrixTextMessage: (messageText) => {
    //
  },
  handleDeleteMatrixEvent: (eventToDelete, eventsToDelete) => {
    //
  },
  handleSendSystemMessage: (actionType, messageAdditionalDataType) => {
    //
  },
  handleListScrolledToNewestEvent: () => {
    //
  },
  handleResetMatrixEventsUpdatedState: () => {
    //
  },
  handleOpenUserDialog: () => {
    //
  },
  handleCloseUserDialog: () => {
    //
  },
  handleMouseEnterEvent: (hoveredEvent) => {
    //
  },
  handleMouseLeaveEvent: () => {
    //
  },
  handleSetEventRead: (eventToSetRead) => {
    //
  },
  handleSetAllEventsRead: () => {
    //
  },

  handleOpenMultimediaDialog: () => {
    //
  },
  handleCloseMultimediaDialog: () => {
    //
  },

  handleCancelMultimediaFileUpload: (index) => {
    //
  },

  handleDownloadSingleMultimedia: (multimediaInfo) => {
    //
  },
  handleDownloadMultipleMultimedia: (multimediaInfo) => {
    //
  },
  handleDeleteImage: (parentImage, imageToDeleteUrl) => {
    //
  },
  handleResetSendingImagesState: () => {
    //
  },
  handleFinishedSendingImages: () => {
    //
  },
  handleUploadMultimediaFiles: (filesToUpload) => {
    //
  },
  handleSendMultimediaFiles: (multimediaFiles, text) => {
    //
  },
  handleSelectMultimediaTypeUploaded: (multimediaType) => {
    //
  },
  handleCloseWindowChat: () => {
    //
  },
  handleSendDirectMessage: (message, invitedUserMail) => {
    //
  }
};

const MatrixRoomContext = createContext<MatrixRoomContextType>(defaultContext);

export default MatrixRoomContext;
